export class TaggedResource {
    selfhelpTaggedResourcesId: number;
    workflowId: number;
    resourceId: string;
    tagId: number;
    date_created: Date;
    date_modified: Date;
}
